import { render, staticRenderFns } from "./RecategorizationTableComponent.vue?vue&type=template&id=3aee6d84"
import script from "./RecategorizationTableComponent.vue?vue&type=script&lang=js"
export * from "./RecategorizationTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports